export default __webpack_public_path__ + "static/media/INTERVIEW.cdbe3a35.pdf";